import React from 'react';
import ReservationSegmentCardDetails from './tabs/ReservationSegmentCardDetails';
import ReservationSegmentCardFolios from './tabs/ReservationSegmentCardFolios';
import ReservationSegmentCardHousekeeping from './tabs/ReservationSegmentCardHousekeeping';
import ReservationSegmentCardServiceLogs from './tabs/ReservationSegmentCardServiceLogs';
import ReservationSegmentCardNotes from './tabs/ReservationSegmentCardNotes';
import ReservationSegmentCardForms from './tabs/ReservationSegmentCardForms';
import ReservationRuQueueLogs from './tabs/ReservationRuQueueLogs';
import EmailTab from './tabs/EmailTab';
import MessageLog from '../MessageLog/MessageLog';
import ReservationSegmentCardSystemNotifications from './tabs/ReservationSegmentCardSystemNotifications';

export default class ReservationSegmentCardWorkspace extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    return(
      <div>
        <div className="tab-content">
          <ReservationSegmentCardDetails {...this.props} />
          <ReservationSegmentCardFolios {...this.props} print_button={true} />
          <EmailTab {...this.props} sent_email_data_table_path={this.props.reservation_segment.sent_email_data_table_path} scheduled_email_data_table_path={this.props.reservation_segment.scheduled_email_data_table_path}/>
          {this.props.property.enable_messaging && this.props.reservation_segment.status != "held" ? <MessageLog {...this.props} sent_message_data_table_path={this.props.reservation_segment.sent_message_data_table_path} scheduled_message_data_table_path={this.props.reservation_segment.scheduled_message_data_table_path}/> : null}
          <ReservationSegmentCardHousekeeping {...this.props} print_button={true} />
          <ReservationSegmentCardServiceLogs {...this.props} print_button={true} />
          <ReservationSegmentCardNotes {...this.props} print_button={true} />
          {this.props.reservation_segment.status != "held" ? <ReservationSegmentCardForms {...this.props}  print_button={true} /> : null}
          <ReservationRuQueueLogs {...this.props} />
          <ReservationSegmentCardSystemNotifications {...this.props} system_notifications_data_table_path={this.props.reservation_segment.system_notifications_data_table_path}/>
          {this.renderReservationTotal()}
        </div>
      </div>
    );
  };

  renderReservationTotal() {
    if (this.props.reservation_segment.balance_amount && this.props.reservation_segment.balance_amount != 0) {
      return (
        <div className="accommodations-price-footer">
          <p className="lead" style={{marginBottom: 0}}>
            <label style={{marginBottom: 0}}>{I18n.t('room_total_difference')}:</label>&nbsp;
            $ {((this.props.reservation_segment.balance_amount) / 100).toFixed(2)}
          </p>
        </div>
      );
    } else {
      return null;
    };
  };

};
